import React, { useEffect } from 'react';

// i18n
import { withTranslation } from 'react-i18next';
import { Button } from '@betareader/design-system';

// Routes
import { withRouter } from 'react-router-dom';


// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchInboxes
} from '../../modules/manuscriptInbox';

import { authUtil, featureToggleUtil, uxAnalyticsUtil } from '../../utils';
import { PaddedWrapper } from '../../style';
import styled from 'styled-components';

const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
`;

const InboxList = styled.ul`
  display: grid;
  gap: var(--br-space-2);
  list-style: none;
  margin: var(--br-space-4) 0;
  padding: 0;
`;

const InboxLink = styled.button`
  background: var(--br-surface);
  border: 1px solid var(--br-border);
  border-radius: var(--br-control-radius);
  color: var(--br-text);
  cursor: pointer;
  display: grid;
  gap: var(--br-space-1);
  padding: var(--br-space-4);
  text-align: left;
  width: 100%;

  &:hover { background: var(--br-hover-surface); }
  &:focus-visible { outline: 2px solid var(--br-focus); outline-offset: 2px; }
`;

export const ManuscriptInboxList = ({
  match, changePage, fetchInboxes, inboxes, userProfile, t
}) => {
  useEffect(() => {
    const fetchOwnInboxes = async () => {
      const idToken = await authUtil.getFreshIdToken();
      fetchInboxes(idToken, { filter: 'own' });
    }
    fetchOwnInboxes();
    uxAnalyticsUtil.trackPageView(match.path);
  }, []);

  return (
    <PaddedWrapper>
      {featureToggleUtil.hasFeatureAccess(userProfile, 'manuscript-inbox') && (
        <ButtonWrapper>
          <Button><span aria-hidden='true'>＋</span> {t('Add')}</Button>
        </ButtonWrapper>
      )}
      <InboxList>
        {inboxes.map(inbox => (
          <li key={inbox._id}>
            <InboxLink type='button' onClick={() => changePage(`/manuscript-inbox/${inbox._id}`)}>
              <strong>{inbox.title}</strong>
              <span>{inbox.description}</span>
            </InboxLink>
          </li>
        ))}
      </InboxList>
    </PaddedWrapper>
  );
}

// redux stuff
const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  inboxes: state.manuscriptInbox.inboxes
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchInboxes,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManuscriptInboxList)));
